import { Badge, Modal, Pagination } from 'react-bootstrap';
import { Product } from '../types/Product';
import styles from './RSCatalogProductModal.module.css';

type Props = {
  product: Product;
  onHide: () => void;
  onPreviousButtonClick: () => void;
  onNextButtonClick: () => void;
};

export const RSCatalogProductModal = ({ product, onHide, onPreviousButtonClick, onNextButtonClick }: Props) => {
  return (
    <Modal show={true} size="lg" onHide={onHide}>
      <Modal.Header closeButton>
        <div>
          <Badge bg="primary">{product.target}</Badge>
          <Modal.Title>{product.satellite}</Modal.Title>
        </div>
      </Modal.Header>
      <Modal.Body>
        <dl className="row">
          <dt className="col-sm-3">プロダクト</dt>
          <dd className={`col-sm-9 ${styles.multilineText}`}>{product.name}</dd>
          <dt className="col-sm-3">センサ</dt>
          <dd className="col-sm-9">
            <b>{product.sensor || '-'}</b>
            <br />
            {product.sensorJa}
          </dd>
          <dt className="col-sm-3">分解能</dt>
          <dd className={`col-sm-9 ${styles.multilineText}`}>{product.resolution || '-'}</dd>
          <dt className="col-sm-3">再訪頻度</dt>
          <dd className="col-sm-9">
            {product.revisitFrequencyUpper && product.revisitFrequencyUpper !== product.revisitFrequencyLower
              ? `${product.revisitFrequencyLower}～${product.revisitFrequencyUpper}`
              : product.revisitFrequencyLower || '-'}
          </dd>
          <dt className="col-sm-3">観測期間</dt>
          <dd className="col-sm-9">
            {product.observationBegin ? `${product.observationBegin}～${product.observationEnd || ''}` : '-'}
          </dd>
          <dt className="col-sm-3">データ形式</dt>
          <dd className={`col-sm-9 ${styles.multilineText}`}>{product.dataFormat || '-'}</dd>
          <dt className="col-sm-3">提供方法</dt>
          <dd className={`col-sm-9 ${styles.multilineText}`}>{product.media}</dd>
          <dt className="col-sm-3">提供機関</dt>
          <dd className="col-sm-9">{product.provider}</dd>
          <dt className="col-sm-3">料金</dt>
          <dd className="col-sm-9">
            {product.fee === '無償' ? (
              <Badge bg="success">無償</Badge>
            ) : product.fee === '有償' ? (
              <Badge bg="warning" text="dark">
                有償
              </Badge>
            ) : (
              product.fee
            )}
          </dd>
          {product.note ? (
            <>
              <dt className="col-sm-3">備考</dt>
              <dd className={`col-sm-9 ${styles.multilineText}`}>{product.note}</dd>
            </>
          ) : null}
          <dt className="col-sm-3">URL</dt>
          <dd className="col-sm-9">
            <ul className="list-unstyled">
              {product.urls.map((url) => (
                <li key={url} className="text-break">
                  <a href={url} target="_blank" rel="noreferrer">
                    {url}
                  </a>
                </li>
              ))}
            </ul>
          </dd>
        </dl>
      </Modal.Body>
      <Modal.Footer className="justify-content-center">
        <Pagination>
          <Pagination.Item onClick={onPreviousButtonClick}>&lt; 前へ</Pagination.Item>
          <Pagination.Item onClick={onNextButtonClick}>次へ &gt;</Pagination.Item>
        </Pagination>
      </Modal.Footer>
    </Modal>
  );
};
